<div class="tab-content">
  <div class="tab-header-row">
    <h2>Customer Notes</h2>
    <button mat-button class="btn-bg-green" [disabled]="!canEdit" (click)="openNoteForm()">Add Note</button>
  </div>

  <div class="notes-list">
    @for (note of Notes; track note.NoteVersionID) {
      <div class="note-card" [class.not-editable]="!canEdit" (click)="openNoteForm(note)">
        <div class="note-header">
          <strong>{{note.DateDisplay}} &middot; {{note.AuthorDisplay}}</strong>
        </div>
        <p class="note-text">{{note.NoteText}}</p>
        <div class="note-footer">
          C Market: {{note.CMarketValue != null ? (note.CMarketValue | number: '1.2-2') : '—'}} &middot; Related: {{note.RelatedDisplay}}
          <span class="history-link" (click)="viewHistory(note); $event.stopPropagation()">History</span>
        </div>
      </div>
    }
    @empty {
      <div class="empty-state">
        <p>No notes yet for this customer.</p>
      </div>
    }
  </div>
</div>
